import {
  Box,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import BackButton from "../../components/common/Backbutton";
import Heading from "../../components/Heading";
import CommonButton from "../../components/common/Button";
import { useNavigate } from "react-router-dom";
import { SampleRequestDetail } from "../../Service/sample.service";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { FiEdit } from "react-icons/fi";
import { FaFilePdf } from "react-icons/fa6";
import CommonModal from "../../components/common/Modal";


const View_Sample_Requester = () => {
  const navigate = useNavigate();
  const [sampleRequest, setSampleRequestData] = React.useState({});
  const { state } = useLocation();
  useEffect(() => {
    if (state && state?.id) {
      getSampleRequest(state.id);
    }
  }, [state]);

  const [rows, setRows] = useState([
    { id: 0, status: 1 },
    { id: 1, status: 2 },
    { id: 2, status: 3 },
    { id: 3, status: 4 },
    { id: 4, status: 5 },
  ]);

  const updateRowStatus = (id, newStatus) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, status: newStatus } : row
      )
    );
  };

  const StatusDropdown = ({ row, onStatusChange }) => (
    <Select
      value={row.status}
      onChange={(e) => onStatusChange(row.id, e.target.value)}
      onClick={(e) => e.stopPropagation()} // Prevent table row click
      sx={{
        borderRadius: 3,
        border: "1px solid gray",
        "& .MuiSelect-outlined": {
          display: "flex",
          alignItems: "center",
          padding: "5px 10px",
        },
        color: "white",
      }}
    >
      {[
        { value: 1, label: "Pending" },
        { value: 2, label: "Confirm" },
        { value: 3, label: "Production" },
        { value: 4, label: "Cancle" },
      ].map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
  const getSampleRequest = async (id) => {
    let res = await SampleRequestDetail(id);
    if (res?.status) {
      setSampleRequestData(res.data);
    } else {
      setSampleRequestData({});
    }
  }
  const [isModalOpen, setIsModalOpen] = React.useState({
    open: false,
    currentComponent: "",
    id: "",
  });
  return (
    <>
      <Stack gap={2}>
        <Box display={"flex"} justifyContent={"space-between"}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            gap={1}
            alignItems={"center"}
          >
            <BackButton />
            <Heading head={`${sampleRequest?.dealerId?.authPersonName}`} />
          </Box>
          <Box display={"flex"} gap={2}>
            <CommonButton buttonName="History" color="primary" onClick={() => {
              setIsModalOpen({
                open: true,
                currentComponent: "history_Modal",
              });
            }} />
            <CommonButton buttonName="Edit" color="secondary" onClick={() => navigate("/sample-form-edit", { state: { id: state?.id, isEdit: true } })} startIcon={<FiEdit />} />
            <CommonButton buttonName="Export" color="white" onClick={() => navigate("/selection-invoice", { state: { id: state?.id } })} startIcon={<FaFilePdf />} />
          </Box>
        </Box>
        <Paper elevation={3} sx={{ p: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <Box className="card-details">
                <Typography>Firm Name :</Typography>
                <Typography>{sampleRequest?.dealerId?.firmName}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Box className="card-details">
                <Typography>Person Name :</Typography>
                <Typography>{sampleRequest?.dealerId?.authPersonName}</Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Box className="card-details">
                <Typography>City :</Typography>
                <Typography>{sampleRequest?.dealerId?.city}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Box className="card-details">
                <Typography>State :</Typography>
                <Typography>{sampleRequest?.dealerId?.state}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Box className="card-details">
                <Typography>Zip Code :</Typography>
                <Typography>{sampleRequest?.dealerId?.pincode}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Box className="card-details">
                <Typography>Date :</Typography>
                <Typography>{sampleRequest && sampleRequest?.dealerId && sampleRequest?.dealerId?.date && sampleRequest?.dealerId?.date ? moment(sampleRequest?.dealerId?.date).format("YYYY-MM-DD") : "-"}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Box className="card-details">
                <Typography>GST Number :</Typography>
                <Typography>{sampleRequest?.dealerId?.gstNuumber}</Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Box className="card-details">
                <Typography>Category :</Typography>
                <Typography>{sampleRequest?.categoryId?.categoryName}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Box className="card-details">
                <Typography>Rough Pads :</Typography>
                <Typography>{sampleRequest?.roughPads}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Box className="card-details">
                <Typography>Pen Packets :</Typography>
                <Typography>{sampleRequest?.penPocket}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Box className="card-details">
                <Typography>Loading DATE :</Typography>
                <Typography>{sampleRequest && sampleRequest?.loadingDate ? moment(sampleRequest?.loadingDate).format('YYYY/MM/DD') : "-"}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Box className="card-details">
                <Typography>Processing Start DATE :</Typography>
                <Typography>{sampleRequest && sampleRequest?.processStartDate ? moment(sampleRequest?.processStartDate).format('YYYY/MM/DD') : "-"}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Box className="card-details">
                <Typography>Material Ready DATE:</Typography>
                <Typography>{sampleRequest && sampleRequest?.materialReadyDate ? moment(sampleRequest?.materialReadyDate).format("YYYY/MM/DD") : "-"}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Box className="card-details">
                <Typography>Sales Representative :</Typography>
                <Typography>
                  {sampleRequest?.salesRepresentative?.firstName && sampleRequest?.salesRepresentative?.lastName
                    ? `${sampleRequest.salesRepresentative.firstName}  ${sampleRequest.salesRepresentative.lastName}`
                    : ""}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Paper>
        <TableContainer component={Paper} sx={{ maxHeight: "500px" }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Size</TableCell>
                <TableCell>Surface</TableCell>
                <TableCell>Design Name</TableCell>
                <TableCell>Sample</TableCell>
                <TableCell>Preview</TableCell>
                <TableCell>Preview Size</TableCell>
                <TableCell>QR</TableCell>
                <TableCell>Status</TableCell>
                {/* <TableCell>Small PCS</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {sampleRequest?.sampleProducts?.map((item, index) => (
                // item.surfaces.map((surface, subIndex) => (
                <TableRow
                  // key={`${index}-${subIndex}`}
                  sx={{
                    "&:hover": {
                      boxShadow: "none !important",
                      backgroundColor: "transparent !important",
                    },
                  }}
                >
                  {/* {subIndex === 0 && (
                      <TableCell rowSpan={item.surfaces.length}>
                        {surface.Surface}
                      </TableCell>
                    )} */}
                  <TableCell>{item?.size?.sizeName}</TableCell>
                  <TableCell>{item?.surface?.surfaceName}</TableCell>
                  <TableCell>{item?.design?.productName}</TableCell>
                  <TableCell>{item?.sample}</TableCell>
                  <TableCell>{item?.preview === 1 ? "Yes" : "No"}</TableCell>
                  <TableCell>{item?.previewsize}</TableCell>
                  <TableCell>{item?.qr === 1 ? "Yes" : "No"}</TableCell>
                  {/* <TableCell>{item?.smallPCS === 1 ? "Yes" : "No"}</TableCell> */}
                  <TableCell>
                    <StatusDropdown
                      row={item}
                      onStatusChange={(id, newStatus) => {
                        updateRowStatus(id, newStatus);
                        setIsModalOpen({
                          open: true,
                          currentComponent: "updatestatus",
                          id,
                          status: newStatus,
                          flag: "product",
                        });
                      }}
                    />
                  </TableCell>
                </TableRow>
                // )
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Paper elevation={3} sx={{ p: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box>
                <Typography fontWeight={800}>Notes :</Typography>
                <Box>
                  <Typography>
                    {sampleRequest?.notes}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Stack>
      <CommonModal
        modalOpen={isModalOpen}
        handleClose={() => {
          setIsModalOpen({ open: false, currentComponent: "", id: "" });
          getSampleRequest(state.id);
        }}
      />
    </>
  );
};

export default View_Sample_Requester;
